import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, combineLatest, map, Subscription } from 'rxjs';
import { MouldPerformanceData } from 'src/app/models/domain/mould-performance-data';
import { EquipmentFacadeService } from 'src/app/services/equipment-facade.service';
import { DesignService, MouldCardService } from 'src/app/state';

@Component({
  selector: 'em-mould-card-details',
  templateUrl: './mould-card-details.component.html',
  standalone: false,
})
export class MouldCardDetailsComponent implements OnInit {
  public pfd$ = new BehaviorSubject<MouldPerformanceData | undefined>(undefined);
  public error$ = new BehaviorSubject<string | undefined>(undefined);

  public designLoading$ = this.designService.loading$;
  public equipmentLoading$ = this.equipmentFacade.loading$;

  public loading$ = combineLatest([this.designLoading$, this.equipmentLoading$]).pipe(
    map(([designLoading, equipmentLoading]) => designLoading || equipmentLoading)
  );

  private readonly subscriptions = new Subscription();

  public constructor(
    private readonly mouldCardService: MouldCardService,
    private readonly equipmentFacade: EquipmentFacadeService,
    private readonly designService: DesignService
  ) {}

  public ngOnInit(): void {
    this.subscriptions.add(
      this.mouldCardService.loadByActiveEquipment().subscribe({
        next: (pfd) => {
          this.pfd$.next(pfd);
          this.error$.next(undefined);
        },
        error: (err) => {
          console.error('Unexpected error fetching Performance Data', err);
          this.error$.next('Unexpected error loading Performance Data.');
          this.pfd$.next(undefined);
        },
      })
    );
  }
}
